import ICONS from '@/shared/entities/constants/icons';
import React, { Dispatch, SetStateAction } from 'react';
import { Button, Image, Text } from 'vkit/lib/components';
import { Grid, Row } from 'vkit/lib/context';

interface TextSuccessProps {
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const TextSuccess: React.FC<TextSuccessProps> = ({ setOpen }) => {
  return (
    <Grid column alignContent='justify' stretch>
      <Text
        value='Existem procedimentos para serem rotulados'
        title
        size='larger'
        color='colorDefault'
      />
      <Text
        value='Agora, o Time de Saúde deve adicionar as descrições e os rótulos dos procedimentos para dar continuidade ao processo de isenção de coparticipação.'
        size='medium'
      />
      <Grid column gap={10}>
        <Text value='Etapas:' title />
        <Text
          icon={ICONS.CHECK}
          iconColor='success'
          value='Aprovar arquivo de isenção'
          size='medium'
        />
        <Grid gap={8} alignItems='center'>
          <div style={{ width: 20 }}>
            <Image src={ICONS.HOURGLASS} width='20px' height='20px' />
          </div>
          <Text value='Time de Saúde adiciona descrições' size='medium' />
        </Grid>
        <Grid gap={8} alignItems='center'>
          <div style={{ width: 20 }}>
            <Image src={ICONS.HOURGLASS} width='20px' height='20px' />
          </div>
          <Text value='Time de Saúde preenche os rótulos dos procedimentos' size='medium' />
        </Grid>
      </Grid>
      <Button onClick={() => setOpen(false)} full bold color='colorDefault'>
        <Row>Concluir</Row>
      </Button>
    </Grid>
  );
};
